import type { ReactNode } from "react";
import { SheetContent, SheetTitle } from "@workspace/ui/components/ui/sheet";

/** Reserve a safe-area-aware close row above both guest and account content. */
export function MobileNavigationSheetContent({ title, children }: { title: string; children: ReactNode }) {
  return (
    <SheetContent
      data-testid="mobile-nav-sheet"
      side="right"
      className="w-full !max-w-none overflow-y-auto p-0 sm:!max-w-sm md:hidden"
      closeButtonClassName="top-[max(1rem,env(safe-area-inset-top))] h-11 w-11 rounded-full bg-gray-100 text-gray-700 opacity-100 hover:bg-gray-200 focus:ring-0 focus:ring-offset-0 focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
      aria-describedby={undefined}
    >
      <SheetTitle className="sr-only">{title}</SheetTitle>
      <div data-testid="mobile-nav-content" className="space-y-1 px-4 pb-8 pt-[calc(max(1rem,env(safe-area-inset-top))+3.5rem)]">
        {children}
      </div>
    </SheetContent>
  );
}
